import { render } from "./game-section.vue?vue&type=template&id=71d4c74c"
import script from "./game-section.vue?vue&type=script&lang=js"
export * from "./game-section.vue?vue&type=script&lang=js"

import "./game-section.vue?vue&type=style&index=0&id=71d4c74c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__